// extracted by mini-css-extract-plugin
export default {"modalCheckImage":"styles_modalCheckImage__GE-28"};